/** App shell: top bar, primary navigation, sign-out. */

export const shell = {
  navHome: 'Home',
  navFlows: 'Flows',
  navActive: 'Active runs',
  navHistory: 'History',
  navMemories: 'Memories',
  navAccess: 'Access',
  navTenants: 'Tenants',
  signOut: 'Sign out',
  /** Label of the company switcher, shown when the person belongs to more than one. */
  switchCompany: 'Company',
  switchCompanyFailed: 'Could not switch company. Try again.',
  toggleNavigation: 'Toggle navigation'
}
